<mat-card>
  <mat-card-content>
    @switch (uiState) {
      @case (uiStateForTemplate.ShowLoading) {
        <div class="loading-container" data-testid="loading-indicator">
          <mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
          <p>Loading player strips...</p>
        </div>
      }
      @case (uiStateForTemplate.ShowData) {
        <div class="flex-col mb-3">
          <button class="red-text margin-top-med"
                  (click)="onDeactivateStripsClick()"
                  data-testid="deactivate-strips-button"
                  mat-stroked-button>
            <mat-icon>do_disturb</mat-icon>
            Deactivate Strips
          </button>
        </div>

        <div class="mb-3">
          <h3>Ticket Strips in Current Draw</h3>
          <ag-grid-angular
            id="playedStripsGrid"
            class="ag-theme-quartz margin-top-med"
            data-testid="played-strips-table"
            [tooltipShowDelay]=0
            rowClass="table-row"
            domLayout='autoHeight'
            overlayNoRowsTemplate="<span>This user has no strips played in the current draw</span>"
            (gridReady)="onPlayedStripsGridReady($event)"
            [rowData]="playedStripRows"
            [columnDefs]="playedStripsColumnDefs">
          </ag-grid-angular>
        </div>

        @if (failedAutoplayStrips.length > 0) {
          <div class="mb-3">
            <h3>Failed Autoplay Strips</h3>
            <ag-grid-angular
              id="failedAutoplayStripsGrid"
              class="ag-theme-quartz margin-top-med"
              data-testid="failed-autoplays-table"
              [tooltipShowDelay]=0
              rowClass="table-row"
              domLayout='autoHeight'
              overlayNoRowsTemplate="<span>No failed autoplay strips</span>"
              (gridReady)="onFailedAutoplayStripsGridReady($event)"
              (rowClicked)="onFailedAutoplayStripRowClick($event)"
              [rowData]="failedAutoplayStrips"
              [columnDefs]="failedAutoplayColumnDefs">
            </ag-grid-angular>
          </div>
        }

        <div class="mb-3">
          <h3>All Active Ticket Strips</h3>
          <ag-grid-angular
            id="allStripsGrid"
            class="ag-theme-quartz margin-top-med large-table"
            data-testid="all-strips-table"
            [tooltipShowDelay]=0
            rowClass="table-row"
            domLayout='autoHeight'
            overlayNoRowsTemplate="<span>This player has no strips for this game</span>"
            (gridReady)="onAllStripsGridReady($event)"
            [rowData]="allStrips"
            [columnDefs]="allStripsColumnDefs">
          </ag-grid-angular>
        </div>

        <div class="mb-3">
          <h3>Deactivated Ticket Strips</h3>
          <ag-grid-angular
            id="deactivated-strips-table"
            class="ag-theme-quartz margin-top-med large-table"
            data-testid="deactivated-strips-table"
            [tooltipShowDelay]=0
            rowClass="table-row"
            domLayout='autoHeight'
            overlayNoRowsTemplate="<span>This player has no deactivated strips for this game</span>"
            (gridReady)="onDeactivatedStripsGridReady($event)"
            [rowData]="deactivatedStrips"
            [columnDefs]="deactivatedStripsColumnDefs">
          </ag-grid-angular>
        </div>
      }
    }
  </mat-card-content>
</mat-card>
